import Fetcher from "./Shared/FetchService";
const advisorUrl = "/aviso/advisor/";
const academicPlanUrl = "/aviso/academicPlan/";
export default class AcademicPlanService {
    static getActivity() {
        return Fetcher.getSingleResponse(advisorUrl + "activity");
    }
    static getPlan() {
        return Fetcher.get(academicPlanUrl + "getPlan");
    }
    static getAcademicPlanTermStatusForOffPlanAlertCreatedDate(studentAffiliationId, offPlanAlertCreatedDate) {
        return Fetcher.getSingleResponse(`${academicPlanUrl}getAcademicPlanTermStatusForOffPlanAlertCreatedDate`, { studentAffiliationId, offPlanAlertCreatedDate });
    }
    // @ts-expect-error - TS2314 - Generic type 'Promise<T>' requires 1 type argument(s).
    static getPlanStatusSummary() {
        return Fetcher.get(`${academicPlanUrl}planStatusSummary`);
    }
    static search(criteria) {
        // @ts-expect-error - TS2322 - Type 'Promise<PagedResult<AcademicPlanDto[]>>' is not assignable to type 'Promise<PagedResponse<AcademicPlanDto[]>>'.
        return Fetcher.getPagedResponse(`${academicPlanUrl}search`, criteria);
    }
}
